import { gql } from "@grandvisionhq/graphql";
const storeById = gql`
  fragment CancelAppointment_StoreById on Store {
    town
    additionalStreetInfo
    streetNumber
    streetName
    name
    postalCode
    code
    globalStoreId
  }
`;
const GET_STORE_BY_ID = gql`
  query CancelAppointment_GetStoreById($globalStoreId: ID) {
    store(globalStoreId: $globalStoreId) {
      ...CancelAppointment_StoreById
    }
  }
  ${storeById}
`;
export {
  GET_STORE_BY_ID
};
//# sourceMappingURL=get-store-by-id.js.map
